<template>
  <div>
    <ul class="nav nav-tabs nav tabs-bordered" role="tablist">
      <li :class="{ active: selectedMenuItem === 1 }">
        <router-link
          :to="`/${routePath}/settings`"
          data-toggle="tab"
          data-test="center-tab-general"
          role="tab"
        >
          <span>{{ trans("center.groupMenuLabelGeneral") }}</span>
        </router-link>
      </li>
      <li v-if="isRegionRoute" :class="{ active: selectedMenuItem === 6 }">
        <router-link
          :to="`/${routePath}/features`"
          data-toggle="tab"
          data-test="center-tab-features"
          role="tab"
        >
          <span>{{ trans("center.groupMenuLabelSettings") }}</span>
        </router-link>
      </li>
      <li v-if="!isAdminRoute" :class="{ active: selectedMenuItem === 2 }">
        <router-link
          :to="`/${routePath}/users`"
          data-toggle="tab"
          data-test="center-tab-users"
          role="tab"
        >
          <span>{{ trans("center.centerUsers") }}</span>
        </router-link>
      </li>
      <li v-if="groupsEnabled" :class="{ active: selectedMenuItem === 3 }">
        <router-link
          :to="`/${routePath}/groups`"
          data-toggle="tab"
          data-test="center-tab-groups"
          role="tab"
        >
          <span>{{ trans("center.groupMenuLabelGroups") }}</span>
        </router-link>
      </li>
      <li
        v-if="!isRegionRoute && !isAdminRoute"
        :class="{ active: selectedMenuItem === 4 }"
      >
        <router-link
          to="/center/patients"
          data-toggle="tab"
          data-test="center-tab-patients"
          role="tab"
        >
          <span>{{ trans("menu.patients") }}</span>
        </router-link>
      </li>
      <li
        v-if="!isRegionRoute && !isAdminRoute"
        :class="{ active: selectedMenuItem === 5 }"
      >
        <router-link
          to="/center/export"
          data-toggle="tab"
          data-test="center-tab-export"
          role="tab"
        >
          <span>{{ trans("center.centerExport") }}</span>
        </router-link>
      </li>
      <li
        v-if="!isRegionRoute && !isAdminRoute"
        :class="{ active: selectedMenuItem === 7 }"
      >
        <router-link
          to="/center/cdr"
          data-toggle="tab"
          data-test="center-tab-cdr"
          role="tab"
        >
          <span>{{ trans("admin.cdr.title") }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["selectedMenuItem", "centerNotActive", "disableGroupsMenu"],
  computed: {
    routePath() {
      if (this.$can("manage_dermicus") && this.isAdminRoute) {
        return `admin/centers/${this.$route.params.id}`;
      } else if (this.isRegionRoute) {
        return `region/centers/${this.$route.params.id}`;
      }
      return "center";
    },
    isAdminRoute() {
      return this.$route.path.includes("admin");
    },
    isRegionRoute() {
      return this.$route.path.includes("region");
    },
    groupsEnabled() {
      return !this.$props.disableGroupsMenu && !this.centerNotActive;
    },
  },
};
</script>
